import { Approval, ApprovalStatus, OnboardingUnion } from 'graphql/types'
import { DataStore } from 'interfaces'
import { GqlApiError } from 'lib/gql/GqlApiError'
import { makeAutoObservable } from 'mobx'
import { isCreatorOnboarding } from '../interfaces/guards'

const ACTIVE_STATUSES = [ApprovalStatus.REQUESTED, ApprovalStatus.PENDING, ApprovalStatus.SUBMITTED]

export class UserOnboardingStore implements DataStore<OnboardingUnion> {
  private _isFetching = false
  private _data?: OnboardingUnion = undefined
  private _error?: GqlApiError = undefined

  constructor(data: Partial<UserOnboardingStore>) {
    if (data.isFetching) this.isFetching = data.isFetching
    if (data.data) this._data = data.data
    makeAutoObservable(this)
  }

  get isFetching() {
    return this._isFetching
  }

  set isFetching(v: boolean) {
    this._isFetching = v
  }

  get data() {
    return this._data
  }

  set data(data: OnboardingUnion | undefined) {
    this._data = data
    if (data) this.isFetching = false
  }

  get error() {
    return this._error
  }

  set error(error: GqlApiError | undefined) {
    this._error = error
    if (error) this.isFetching = false
  }

  get creatorApprovals() {
    return isCreatorOnboarding(this.data) ? this.data.approvals : []
  }

  get hasActiveCreatorApproval() {
    return Boolean(
      this.creatorApprovals?.some((approval) => ACTIVE_STATUSES.includes(approval.approvalStatus))
    )
  }

  appendCreatorApprovals(newApprovals: Approval | Approval[]) {
    if (isCreatorOnboarding(this.data)) {
      this.data.approvals = [
        ...(Array.isArray(newApprovals) ? newApprovals : [newApprovals]),
        ...this.data.approvals
      ]
    }
  }
}
